import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import styled, { css } from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { Color } from 'style/types';

const diamond = css`
  clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
`;

const Root = styled.div`
  isolation: isolate;
  width: var(--triple-unit);
  height: var(--triple-unit);
  padding: 3px;
  background-color: var(--c-black);
  ${diamond}
`;
const Border = styled.div`
  width: 100%;
  height: 100%;
  padding: 2px;
  ${diamond}

  .checked & {
    padding: 0px;
  }
`;
const Background = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  height: 100%;
  background-color: rgba(var(--c-rgb-black), 0.92);
  ${diamond}

  .checked & {
    background-color: transparent;
  }
`;

type Props = { color: Color; checked?: boolean };
export const BulletPoint = ({ color, checked }: Props) => {
  return (
    <Root className={classNames({ checked })}>
      <Border style={{ backgroundColor: color }}>
        <Background>
          {checked && (
            <FontAwesomeIcon icon={faCheck} color="var(--c-black)" size="2xs" />
          )}
        </Background>
      </Border>
    </Root>
  );
};
